if (!customElements.get("read-more")) {
    class ReadMore extends HTMLElement {
        constructor() {
            super();
            if (!this.dataset.readMoreTarget) return;

            this.container = this;
            this.target = document.getElementById(this.dataset.readMoreTarget);
            this.buttonReadMore = this.querySelector('button[expand]') || this;
            this.buttonLess = this.querySelector('button[less]');
            this.events = ['click', 'keypress'];
        }

        eventInits() {
            this.events.forEach(eventType => {
                this.buttonReadMore?.addEventListener(eventType, (event) => {
                    if (eventType === 'keypress' && event.key !== 'Enter' && event.key !== ' ') return;

                    const isExpanded = this.target.classList.contains('is-expanded');
                    this.target.classList.toggle('is-expanded', !isExpanded);
                    this.buttonLess.removeAttribute('hidden');
                    this.buttonReadMore.setAttribute('hidden', 'hidden');
                });
                this.buttonLess?.addEventListener(eventType, (event) => {
                    if (eventType === 'keypress' && event.key !== 'Enter' && event.key !== ' ') return;

                    this.target.classList.remove('is-expanded');
                    this.buttonReadMore.removeAttribute('hidden');
                    this.buttonLess.setAttribute('hidden', 'hidden');
                });
            });
            this.checkVisibility();
            this.resizeObserver = new ResizeObserver(() => this.checkVisibility());
            this.resizeObserver.observe(this.target);
        }

        checkVisibility() {
            if (!document.querySelector('variant-picker')) {
                return;
            }
            const isFullyVisible = this.target.querySelector('p').scrollHeight <= this.target.querySelector('p').clientHeight;
            if (isFullyVisible) {
                this.buttonReadMore.setAttribute('hidden', 'hidden');
                this.buttonLess?.setAttribute('hidden', 'hidden');
                this.container.style.cssText = 'display: none;';
            } else {
                const isExpanded = this.target.classList.contains('is-expanded');
                if (!isExpanded) {
                    this.buttonReadMore.removeAttribute('hidden');
                }
                this.container.style.cssText = '';
            }
        }

        connectedCallback() {
            this.eventInits();
        }

        disconnectedCallback() {
            this.resizeObserver?.disconnect();
        }
    }

    customElements.define("read-more", ReadMore);
}
